import React, { useState, useEffect, useContext } from 'react';
import { motion } from 'framer-motion';

import Button from '../../shared/components/FormElements/Button/Button';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import './Account.css';
import MainNavigation from '../../components/MainNavigation';

const Account = () => {
    const auth = useContext(AuthContext);
    const [userName, setUserName] = useState();
    const [plan, setPlan] = useState();
    const [ticket, setTicket] = useState()
    const [session, setSession] = useState();
    const [numEvals, setNumEvals] = useState();
    const {isLoading, sendRequest, error, clearError} = useHttpClient();

    useEffect(()=>{
        const fetchUserData = async() => {
            try {
                const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_USER+`/user/${auth.userId}`);
                setUserName(responseData.user.firstName+' '+responseData.user.lastName);
                setPlan(responseData.user.plan);
                setTicket(responseData.user.ticket);
                setSession(responseData.user.interviews.length);
                setNumEvals(responseData.user.numEvals);
            } catch (err) {
                console.log(err);
            }
        };
        fetchUserData();
    },[auth, sendRequest]);


    return (
        <React.Fragment>
            {!isLoading && <MainNavigation />}
            <div className='account-name'>
                <ErrorModal error={error} onClear={clearError}/>
                {isLoading && userName && plan && ticket && session && numEvals && <div className='center'>
                    <LoadingSpinner asOverlay />
                </div>}
                <motion.div 
                    className='account-titles'
                    initial={{ opacity: 0, scale: 1 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.25, duration: 0.5 }}
                    exit={{ opacity: 0, scale: 1 }}
                >
                    <h1>Hi, {userName}!</h1>
                    <p style={{ fontWeight: 'light' }}>Manage your account status here.</p>
                </motion.div>
                <motion.div 
                    className='account-details'
                    initial={{ opacity: 0, scale: 1 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.25, duration: 1 }}
                >
                    <div className='account-numbers'>
                        <div className='account-statistic'>
                            <b>Subscription:</b>
                            <p>{`${plan} + ${ticket} Feedback Packs`}</p>
                        </div>
                        <div className='account-statistic'>
                            <b>Session Used:</b>
                            <p>{`${session} / ${(plan === 'free')? '1': '5'}`}</p>
                        </div>
                        <div className='account-statistic'>
                            <b>Question Used:</b>
                            <p>{`${session*5} / ${(plan === 'free')? '5': '100'}`}</p>
                        </div>
                        <div className='account-statistic'>
                            <b>Feedback Used:</b>
                            <p>{`${numEvals} / ${(plan === 'free')? '10': '200'}`}</p>
                        </div>
                    </div>
                    <div className='account-buttons'>
                        <div className='upgrade-button'><Button to={'/upgrade'} transparent><p style={{ marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem', color: 'white' }}>UPGRADE</p></Button></div>
                        <div className='logout-button'><Button onClick={auth.logout} transparent><p style={{ marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem', color: 'black' }}>LOGOUT</p></Button></div>
                    </div>
                </motion.div>
            </div>
        </React.Fragment>
    );
};

export default Account;